import { CLOSE_MODAL, OPEN_MODAL, CLOSE_DATA_MODAL, OPEN_DATA_MODAL, OPEN_WELCOME, CLOSE_WELCOME } from '../actions/modalActions';

const initial_state = {
  welcome: false,
  open: false,
  openData: false,
  zone: '',
  des: '',
  image: '',
  credits: '',
  imageDes: ''
};

const modalReducer = (state = initial_state, action) => {
  switch (action.type) {
    case OPEN_MODAL: 
      return {
        ...state, 
        open: true, 
        zone: action.zone, 
        des: action.des, 
        image: action.image, 
        credits: action.credits, 
        imageDes: action.imageDes
      };
    case CLOSE_MODAL:
      return {
        ...state, 
        open: false, 
        zone: '', 
        des: '', 
        image: '', 
        credits: '', 
        imageDes: ''
      };
    case OPEN_DATA_MODAL: 
      return {
        ...state, 
        openData: true
      };
    case CLOSE_DATA_MODAL:
      return {
        ...state, 
        openData: false
      };
    case OPEN_WELCOME:
      return {
        ...state, 
        welcome: true,
        zone: action.zone, 
        des: action.des, 
        image: action.image, 
        credits: action.credits, 
        imageDes: action.imageDes
      };
    case CLOSE_WELCOME: 
      return {
        ...state, 
        welcome: false,
        zone: '', 
        des: '', 
        image: '', 
        credits: '', 
        imageDes: ''
      };
    default: 
      return state;
  }
}; 

export default modalReducer;